import React from 'react';
import { FormattedMessage } from '@kyruus/intl';

import { ReviewsHeader, ReviewsTitle } from './styles';
import messages from '../../lib/messages';

const ReviewsSectionHeader = (): React.ReactElement => {
  return (
    <ReviewsHeader>
      <ReviewsTitle>
        <FormattedMessage {...messages.reviewsTitle} />
      </ReviewsTitle>
    </ReviewsHeader>
  );
};

export default ReviewsSectionHeader;
